import { confirm } from 'owa-confirm-dialog';
import { isItemOfMessageType, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import mailStore from 'owa-mail-store/lib/store/Store';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import isSenderSelf from 'owa-mail-store/lib/selectors/isSenderSelf';
/**
 * Get the de-duped senders given the ids
 * @param mailboxes the mailboxes to be sweeped
 * @return the de-duped sweepable mailboxe based on smtp address, null if
 * the email addresses contains user's own email address
 */
export function getFilteredSweepableMailboxes(mailboxes) {
    // Use a dictionary is to de-dup the mailboxes smtp addresses
    var senderInfoDictionary = {};
    var filteredMailboxes = [];
    for (var i = 0; i < mailboxes.length; i++) {
        var emailAddress = mailboxes[i].EmailAddress;
        if (!emailAddress) {
            // Skip the current iteration if there is no valid email address.
            // For example, for emails inside Conversation History, there is no EmailAddress in LastSender's mailbox.
            continue;
        }
        // Show error dialog and early return if the email addresses to block contain user self's email address
        if (isSenderSelf(emailAddress)) {
            confirm(format(strings.errorBlockingSelf, emailAddress), null, false /* resolveImmediately */, {
                hideCancelButton: true,
            });
            return null;
        }
        var smtpAddressLowerCase = emailAddress.toLowerCase();
        // De-dup the mailboxes
        if (!senderInfoDictionary[smtpAddressLowerCase]) {
            // Add smtp address to dictionary if there's no dup
            senderInfoDictionary[smtpAddressLowerCase] = true;
            filteredMailboxes.push(mailboxes[i]);
        }
    }
    // The filtered mailbox can be empty in case there is no EmailAddress in all
    // LastSenders' mailboxes, e.g conversations in Conversation History
    return filteredMailboxes.length > 0 ? filteredMailboxes : null;
}
export function getLastSenderMailboxesFromRowKeys(rowKeys, tableView) {
    var mailboxes = [];
    rowKeys.forEach(function (rowKey) {
        var lastSenderMailbox = MailRowDataPropertyGetter.getLastSenderMailbox(rowKey, tableView);
        if (lastSenderMailbox) {
            mailboxes.push(lastSenderMailbox);
        }
    });
    // Only add mailbox if lastSender is valid. lastSender could be undefined in rowModified notification payload if the message is directly POSTed
    // VSO: 19871 - Sender MBX are already de-duped, make sure this works when we have multi-value sorted tables
    // last sender is same for rows with same conversationId, Discuss how to implement this
    // for multi-value sorts
    return getFilteredSweepableMailboxes(mailboxes);
}
/**
 * Get the mailboxes to block from the selected conversations
 * @param itemIds the item ids
 * @return the filtered sweepable mailboxes
 */
export function tryGetMailboxesFromItemIds(itemIds) {
    var mailboxes = [];
    itemIds.forEach(function (itemId) {
        var item = mailStore.items.get(itemId);
        if (item && isItemOfMessageType(item)) {
            mailboxes.push(item.From.Mailbox);
        }
    });
    return getFilteredSweepableMailboxes(mailboxes);
}
//# sourceMappingURL=getMailboxes.js.map